import React, { useState, useRef, useEffect } from "react";
import "./chat.css";
import QuickActions from "./QuickActions";
import MessageBubble from "./MessageBubble";
import chat_bg1 from './assets/chat_bg1.png';
import chat_bg2 from './assets/chat_bg2.png';
import nora from './assets/nora.png';
import api from "../../services/api";

export default function ChatWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      text: "Hi! I'm Nora, your SalesRoute assistant. Here are a few things I can check for you in real-time:\n\n• Customer Dues: Top overdue balances & credit status\n• Daily Sales: Real-time order progress & revenue\n• Inventory: Live warehouse stock counts\n• Guides: Step-by-step help for any feature",
      sender: "bot",
    },
  ]);

  const [input, setInput] = useState("");
  const chatEndRef = useRef(null);

  // 🔹 Operational Quick Actions
  const [faqData] = useState([
    { id: 1, question: "Top due customers" },
    { id: 2, question: "Today's sales" },
    { id: 3, question: "Check stock" },
  ]);

  // 🔹 Auto scroll
  useEffect(() => {
    if (isOpen) {
      chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, isOpen]);

  // 🔹 Send Message Logic (Calling real Chatbot API)
  const sendMessage = async (text) => {
    if (!text || !text.trim()) return;

    // 1. Add user's question to chat
    setMessages((prev) => [...prev, { text, sender: "user" }]);

    // 2. Add temporary "Thinking..." bot message for loading state
    setMessages((prev) => [...prev, { text: "Thinking...", sender: "bot", isTemp: true }]);

    try {
      // 3. Make POST request to chatbot/ask/ endpoint
      const response = await api.post("chatbot/ask/", { query: text });

      if (response.data && response.data.success && response.data.data) {
        const rawReply = response.data.data.answer;
        const botReply = (rawReply && rawReply.trim()) 
          ? rawReply 
          : "I'm here to help with your SalesRoute questions or live numbers (like customer dues, today's sales, or stock). How can I assist you?";
        const metricCard = response.data.data.metric_card;
        
        // Replace typing state with actual response
        setMessages((prev) =>
          prev.map((msg) =>
            msg.isTemp ? { text: botReply, metric_card: metricCard, sender: "bot" } : msg
          )
        );
      } else {
        const rawMsg = response.data?.message || "";
        const isUserFacingNotice = response.data?.limit_reached || rawMsg.toLowerCase().includes("credit");
        const errorMsg = isUserFacingNotice ? rawMsg : "Sorry, something went wrong. Please try again.";
        setMessages((prev) =>
          prev.map((msg) =>
            msg.isTemp ? { text: errorMsg, sender: "bot" } : msg
          )
        );
      }
    } catch (error) {
      console.error("ChatBot API error:", error);
      const rawMsg = error.response?.data?.message || "";
      const isUserFacingNotice = error.response?.data?.limit_reached || error.response?.status === 403 || rawMsg.toLowerCase().includes("credit");
      const errorMsg = isUserFacingNotice ? rawMsg : "Sorry, something went wrong. Please try again.";
      setMessages((prev) =>
        prev.map((msg) =>
          msg.isTemp ? { text: errorMsg, sender: "bot" } : msg
        )
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    sendMessage(input);
    setInput("");
  };

  return (
    <div className="salesroute-chat-widget-root">
      {isOpen ? (
        <div className="chat-container">
          <div className="app-container">
            <img className="chat_bg1" src={chat_bg1} alt="bg1" />
            <img className="chat_bg2" src={chat_bg2} alt="bg2" />

            {/* Header */}
            <header>
              <div className="header-gradient"></div>
              <div className="header-content">
                <div className="header-top">
                  <div className="avatar bot-avatar">
                    <img src={nora} alt="Nora" />
                  </div>
                  <h1>Nora</h1>
                  <button className="close-btn" onClick={() => setIsOpen(false)} aria-label="Close Chat">
                    <svg width="16" height="16" viewBox="0 0 24 24">
                      <path
                        d="M18 6L6 18M6 6l12 12"
                        stroke="white"
                        strokeWidth="2"
                      />
                    </svg>
                  </button>
                </div>
                <p>
                  I'm Nora, your personal assistant for{" "}
                  SalesRoute.ai related queries.
                </p>
              </div>
            </header>

            {/* Chat Area */}
            <div className="chat-scroll-wrapper">
              <main id="chat-area">
                {messages.map((msg, index) => (
                  <MessageBubble key={index} msg={msg} />
                ))}
                <div ref={chatEndRef}></div>
              </main>
            </div>

            {/* Footer */}
            <footer>
              <QuickActions
                actions={faqData.map((item) => ({
                  label: item.question,
                  value: item.question,
                }))}
                onActionClick={sendMessage}
              />

              <form className="input-container" onSubmit={handleSubmit}>
                <input
                  type="text"
                  placeholder="Ask anything you need..."
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  autoComplete="off"
                />
                <button type="submit" className="send-btn">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                  </svg>
                </button>
              </form>
            </footer>
          </div>
        </div>
      ) : (
        <button className="chat-launcher-btn" onClick={() => setIsOpen(true)} aria-label="Open Chat">
          <div className="launcher-avatar">
            <img src={nora} alt="Nora Avatar" />
          </div>
          <span className="pulse-ring"></span>
        </button>
      )}
    </div>
  );
}
